var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('Doughnut',{attrs:{"chart-options":_vm.chartOptions,"chart-data":{datasets: _vm.datasets,labels: _vm.labels},"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"css-classes":_vm.cssClasses,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }